import { AxiosRequestConfig } from "axios";
import { WeatherModel } from "../../models/WeatherModel";
import { app } from "@/store";

export default function () {
    const APIkey = "a55470f7c5cf12f565c0151bc638d071";
    //const APIkey: string = '8eb6318ee69d1bc91d20ac6184929638'; // SeaSafe dedicated API key
    const getCurrentWeather = (lat: string, lng: string): Promise<any> => {
        const part = "hourly,daily,minutely";
        const url = `https://api.openweathermap.org/data/3.0/onecall?lat=${lat}&lon=${lng}&units=metric&appid=${APIkey}`;
        const config: AxiosRequestConfig = {};
        config.headers = { common: { ["Access-Control-Allow-Origin"]: "*" } };
        return new Promise((resolve, reject) => {
            fetch(url)
                .then(function (response) {
                    response.json().then((value: any) => {
                        const weather = value as WeatherModel;
                        resolve(weather);
                    });
                })
                .then(function (data) {
                    //console.log(data);
                })
                .catch(function () {
                    app.error = "Weather service encountered an error";
                });
        });
    };
    return { getCurrentWeather };
}
